/**
 *
 * IBM Confidential
 *
 * (C) Copyright IBM Corp. 2019, 2025
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U. S. Copyright Office
 *
 * US Government Users Restricted Rights - Use, duplication or
 * disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 *
 **/

// structure based off of: https://github.com/erikras/ducks-modular-redux

const PREFIX = 'navigation/';

// Actions
const UPDATE_HISTORY = `${PREFIX}update-history`;
const TOGGLE_HAS_MENU = `${PREFIX}has-menu`;
const TOGGLE_OPEN_MENU = `${PREFIX}open-menu`;
const ADD_SUB_SECTION = `${PREFIX}add-sub-section`;

// Initial State
export const initial = {
  history: [],
  hasVerticalMenu: false,
  openVerticalMenu: false,
  subSections: {}
};

function createReducer(initial, reducers) {
  const combinedReducer = (state = initial, action) => {
    const { type } = action;
    const handler = reducers[type];
    return handler ? handler(state, action) : state;
  };
  return combinedReducer;
}

export const reducer = createReducer(initial, {
  [UPDATE_HISTORY]: (state, { toState, toParams }) => ({
    ...state,
    history: state.history
      ? [...state.history, { toState, toParams }]
      : [{ toState, toParams }]
  }),
  [TOGGLE_HAS_MENU]: (state, { bool }) => ({
    ...state,
    hasVerticalMenu: bool
  }),
  [TOGGLE_OPEN_MENU]: (state, { bool }) => ({
    ...state,
    openVerticalMenu: bool
  }),
  [ADD_SUB_SECTION]: (state, { section, subSection }) => ({
    ...state,
    subSections: {
      ...state.subSections,
      [section]: subSection
    }
  })
});

export const actions = {
  updateHistory: item => ({
    type: UPDATE_HISTORY,
    toState: item.toState,
    toParams: item.toParams
  }),
  toggleMenu: bool => ({
    type: TOGGLE_HAS_MENU,
    bool
  }),
  toggleOpen: bool => ({
    type: TOGGLE_OPEN_MENU,
    bool
  }),
  addSubSection: (section, subSection) => ({
    type: ADD_SUB_SECTION,
    section,
    subSection
  })
};
